import React from "react";

function ServiceBooking() {
  return <div>ServiceBooking</div>;
}

export default ServiceBooking;
